module.exports = __webpack_public_path__ + "assets/img/5e8976561fe80f430259999aea98f143.svg";